//Test save status
export const STORAGE_SAVE_STATE = 'saveState';
export const STORAGE_SAVE_ERROR_COUNT = 'saveErrorCount';
export const STORAGE_NOTIFIED_SAVE_SUCCESS_COUNT = 'notifiedSaveSuccessCount';
export const STORAGE_NOTIFIED_SAVE_ERROR_COUNT = 'notifiedSaveErrorCount';

export const STORAGE_SIGNED_OBJECT = 'signedObject';
export const STORAGE_PNP = 'pnp';
export const STORAGE_PWA_CONFIG = 'pwaConfig';
export const STORAGE_FORM_INFO = 'formInfo';
export const STORAGE_TEST_STATUS = 'testStatus';
export const STORAGE_PAUSED_BY = 'pausedBy';
export const STORAGE_PAUSED_REASON = 'pausedReason';
export const STORAGE_RESUMED_BY = 'resumedBy';
export const STORAGE_ENDED_ACTION = 'endedAction';
export const STORAGE_STATUS_BEFORE_PAUSE = 'statusBeforePause';

export const STORAGE_ATTEMPT_NO_BEFORE_RELOAD = 'attemptNumBeforeReload';
export const STORAGE_ATTEMPT_NO = 'attemptNumber';

export const STORAGE_AUTH_TOKEN = 'authToken';

export const STORAGE_AUTO_EXIT_SECONDS = 'autoExitSeconds';
export const STORAGE_LAUNCH_AUTO_EXIT_SECONDS = 'launchAutoExitSeconds';

export const STORAGE_LAST_RECORDED_WAKE_TIME = 'lastRecordedWakeTime';

export const STORAGE_PRACTICE_OBJECT = 'practiceObject';

export const STORAGE_PROHIBITED_ACTION = 'prohibitedAction';
export const STORAGE_PROHIBITED_ACTION_COUNTER = 'prohibitedActionCounter'; //for now this only counts fullscreen violation
export const STORAGE_PROCTOR_RESUME_NEEDED = 'proctorResumeNeeded';

//to support the inconsistency of behavior in non-safari, it's better to have our own isFullscreen variable
export const STORAGE_ISFULLSCREEN = 'isFullscreen';

export const STORAGE_VERIFY_CONNECTION = 'verifyConnection';